module.exports = __webpack_public_path__ + "assets/a74e250963f1f54b48b83051a93bea09.mp4";